var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "items-container" },
    [
      _c("v-data-table", {
        staticClass: "data-table",
        attrs: {
          "hide-default-footer": "",
          "items-per-page": -1,
          headers: _setup.headers,
          items: _setup.tableState.data,
          loading: _setup.tableState.isLoading
        },
        scopedSlots: _vm._u([
          {
            key: "item.action",
            fn: function({ item }) {
              return [
                _c(
                  "div",
                  { staticClass: "action" },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: { color: "yellow darken-3" },
                        on: { click: () => _setup.onEditHandler(item.id) }
                      },
                      [_vm._v("mdi-pencil")]
                    )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "item.index",
            fn: function({ index }) {
              return [_c("div", [_vm._v(" " + _vm._s(index + 1) + " ")])]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }